"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.load = exports.save = void 0;
var voyageMessageStarmapCreate_sidecar_1 = require("@voyage/multi/voyageMessageStarmapCreate-sidecar");
var voyageStarmaps_sidecar_1 = require("@voyage/starmap/voyageStarmaps-sidecar");
var namespace = 'voyage-saver-starmap';
var save = function () {
    var sm = voyageStarmaps_sidecar_1.voyageStarmaps.get();
    var d = {
        seed: sm.seed,
        ci: sm.currentI,
        cj: sm.currentJ,
    };
    return d;
};
exports.save = save;
var load = function (d) {
    try {
        voyageMessageStarmapCreate_sidecar_1.voyageMessageStarmapCreate.sendMessageAndImmediatelyExecute({
            seed: d.seed,
            ci: d.ci,
            cj: d.cj,
        });
    }
    catch (err) {
        console.log(namespace, 'load failed', err);
    }
};
exports.load = load;
